import React from "react";

import { useState } from "react";
import { object, array, string, bool } from "prop-types";
import { Popover } from "react-tiny-popover";
import { TableRowMenuIcon, EditIcon } from "../GetSVGs";

const TableRowActions = ({
  actions,
  rowData = {},
  size = "medium",
  isRowClickable = false,
}) => {
  const [open, setOpen] = useState(false);

  const openPopOverHandler = (onClick, rowData) => {
    setOpen(false);
    onClick(rowData);
  };

  const toggle = () => {
    setOpen((prev) => !prev);
  };
  const { node } = rowData;
  return (
    <Popover
      isOpen={open}
      onClickOutside={toggle}
      positions={["top", "botton", "left", "right"]}
      align="end"
      reposition={false}
      content={
        <div className={`table-row-actions table-row-actions--${size}`}>
          {actions.map(({ name, onClick, field, values }, index) => {
            if (
              field &&
              ((typeof field === "function" && values.includes(field(node))) ||
                values.includes(node[field]))
            ) {
              /**
               * Handle custom fields based on their value in the data
               */
              return (
                <button
                  className="table-row-actions__action-button"
                  key={`option-${name}-${index}`}
                  onClick={(e) => {
                    if (isRowClickable) e.stopPropagation();
                    openPopOverHandler(onClick, rowData);
                  }}
                >
                  {name}
                </button>
              );
            } else if (!field) {
              return (
                <button
                  className="table-row-actions__action-button"
                  key={`option-${name}-${index}`}
                  onClick={(e) => {
                    if (isRowClickable) e.stopPropagation();
                    openPopOverHandler(onClick, rowData);
                  }}
                >
                  {name}
                </button>
              );
            }
          })}
        </div>
      }
    >
      <button
        className="table-row-actions__small-menu"
        onClick={(e) => {
          if (isRowClickable) {
            e.stopPropagation();
          }
          if (actions.length > 1) {
            toggle();
          } else if (actions.length === 1 && actions[0].name === "Edit") {
            openPopOverHandler(actions[0].onClick, rowData);
          }
        }}
      >
        {actions.length > 1 && <TableRowMenuIcon />}
        {actions.length === 1 && actions[0].name === "Edit" && <EditIcon />}
      </button>
    </Popover>
  );
};

TableRowActions.propTypes = {
  actions: array,
  rowData: object.isRequired,
  size: string.isRequired,
  isRowClickable: bool,
};

export default TableRowActions;
